import {get} from 'lodash';
import {columnsFn} from './utils';
import moment from 'moment';
import i18n from 'src/i18n';

export function title(model) {
  return model ? i18n.fr('fields.display_name_$first_$last', {
    first: get(model, 'first_name', ''),
    last: get(model, 'last_name', ''),
  }).trim() : '';
}

export const columns = columnsFn(function () {
  return {
    first_name: {type: 'string'},
    last_name: {type: 'string'},
    other_name: {type: 'string'},
    gender: {type: 'select', items: ['gender.m', 'gender.f']},
    hkid: {type: 'string'},
    mobile: {type: 'string'},
    home_tel: {type: 'string'},
    birthday: {type: 'date'},
    age: {
      type: 'label', get(model) {
        return model ? i18n.fr('fields.years_old_$yrs', {yrs: moment().diff(model.birthday, 'years')}) : '';
      },
    },
    height: {type: 'number'},
    weight: {type: 'number'},
    // "email": {type: 'email'},
  };
});



// WEBPACK FOOTER //
// ./src/schemas/profile.js